<template>
  <div class="coupon-claimed">

    <div class="banner">
      <div class="banner-content">
        <div class="banner-title">众连权益.Benefits Platform</div>
        <div class="banner-subtitle">2026 运营商专属数字化权益平台</div>
      </div>
    </div>

    <div class="content">
      <div class="desc">按领取时间倒序</div>

      <van-skeleton v-if="loading" title :row="4" class="sk" />

      <van-empty v-else-if="!claimed || claimed.length === 0" description="暂无领取记录" />

      <div v-else class="list">
        <div class="item" v-for="it in claimed" :key="it.id" @click="goDetail(it)">
          <div class="left">
            <img class="logo" :src="it.icon" />
            <div class="info">
              <div class="name">{{ it.name }}</div>
              <div class="cond">{{ it.condition }}</div>
              <div class="time">{{ displayTime(it) }}</div>
            </div>
          </div>
          <div class="right">
            <div class="status" :class="statusClass(it.status)">{{ statusText(it.status) }}</div>
            <div class="amount"><span class="currency">¥</span>{{ it.amount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClaimedCoupons } from '@/api/coupon'
import { Toast } from 'vant'
export default {
  name: 'couponClaimed',
  data() {
    return {
      claimed: [],
      loading: false
    }
  },
  async mounted() {
    this.loading = true
    try {
      const { data } = await getClaimedCoupons()
      this.claimed = data || []
    } catch (e) {
      Toast.fail('加载失败')
    } finally {
      this.loading = false
    }
  },
  methods: {
    statusText(s) {
      if (s === 'USED') return '已核销'
      if (s === 'EXPIRED') return '已过期'
      return '已领取'
    },
    statusClass(s) {
      if (s === 'USED') return 'redeemed'
      if (s === 'EXPIRED') return 'expired'
      return 'received'
    },
    formatTime(ts) {
      const d = new Date(ts)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${day} ${hh}:${mm}`
    },
    displayTime(it) {
      if (it && it.status === 'RECEIVED') {
        const raw = it.validTo || it.valid_to || it.validEnd || it.valid_end
        if (raw) return `有效期至 ${raw}`
      }
      if (it && it.status === 'USED') {
        const raw = it.validTo || it.valid_to || it.validEnd || it.valid_end
        if (raw) return ``
      }
      return it && it.receivedAt ? this.formatTime(it.receivedAt) : ''
    },
    goDetail(it) {
      this.$router.push({
        name: 'couponDetail',
        params: { id: it.couponId || it.coupon_id || it.couponid || it.id },
        query: {
          name: it.name || '',
          amount: it.amount || '',
          condition: it.condition || '',
          icon: it.icon || '',
          status: it.status || ''
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.coupon-claimed {
  min-height: 100vh;
  background: #f7f7f8;
  padding-bottom: calc(1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
.banner {
  position: relative;
  padding: 1.8rem 0.6rem 1.05rem;
  background: linear-gradient(135deg, #f0a79c 0%, #f4b6ac 45%, #f7c7bf 100%);
  border-bottom: 1px solid #b66c63;
  overflow: hidden;
}
.banner::before,
.banner::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(155, 27, 27, 0.36);
}
.banner::before {
  width: 4.2rem;
  height: 4.2rem;
  top: -2.6rem;
  left: -1.5rem;
}
.banner::after {
  width: 3.6rem;
  height: 3.6rem;
  top: -2.4rem;
  right: -1.4rem;
}
.banner-content {
  position: relative;
  z-index: 1;
  color: #1f2a37;
}
.banner-title {
  font-size: 0.52rem;
  font-weight: 800;
  letter-spacing: 0.01rem;
}
.banner-subtitle {
  margin-top: 0.16rem;
  font-size: 0.3rem;
  color: #6b7280;
}
.content {
  padding: 0.4rem 0.6rem 0.8rem;
  box-sizing: border-box;
}
.desc {
  font-size: 0.32rem;
  color: #8c8c8c;
  margin: 0.25rem 0 0.15rem;
}
.list {
  display: flex;
  flex-direction: column;
  gap: 0.24rem;
  padding-top: 0.1rem;
}
.sk {
  background: #fff;
  border-radius: 0.16rem;
  padding: 0.5rem;
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.42rem 0.34rem;
  background: #fff;
  border-radius: 0.3rem;
  border: 1px solid #eef1f6;
  box-shadow: 0 0.12rem 0.22rem rgba(17, 24, 39, 0.06);
}
.left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}
.logo {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.22rem;
  background: #f4b6ac;
  flex-shrink: 0;
  object-fit: cover;
}
.info {
  margin-left: 0.3rem;
  min-width: 0;
}
.name {
  font-size: 0.42rem;
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 4.8rem;
}
.cond {
  margin-top: 0.08rem;
  font-size: 0.32rem;
  color: #8a8a8a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 4.8rem;
}
.time {
  margin-top: 0.08rem;
  font-size: 0.3rem;
  color: #b0b0b0;
}
.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.16rem;
  flex-shrink: 0;
  margin-left: 0.2rem;
}
.status {
  font-size: 0.3rem;
  padding: 0.08rem 0.18rem;
  border-radius: 0.12rem;
  background: #f5f5f5;
  color: #666;
}
.status.received { background: #f5f5f5; color: #666; }
.status.expired { background: #fff1f0; color: #db3e2f; }
.status.redeemed { background: #f0fff4; color: #22c55e; }
.amount {
  font-size: 0.44rem;
  color: #9b1b1b;
  font-weight: 800;
  line-height: 1;
}
.currency {
  font-size: 0.3rem;
  margin-right: 0.04rem;
  font-weight: 700;
}
</style>
